import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { componentTokens } from "@accredo/fe-shared/theme/index.js";
import { getEuro } from "@accredo/fe-shared/services/formatService.js";

SumInput.propTypes = {
  item: PropTypes.object.isRequired,
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
  default: PropTypes.number,
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
};

export default function SumInput(props) {
  const { item, fields, values, setValues } = props;
  const [sum, setSum] = useState(0);

  useEffect(() => {
    const calculateSum = () => {
      let total = 0;
      fields.forEach((child) => {
        const value = parseFloat(values[child]) || 0;
        total += value;
      });
      setSum(total);
    };

    calculateSum();
  }, [fields, values]);

  useEffect(() => {
    setValues((prevValues) => ({
      ...prevValues,
      [item.name]: sum,
    }));
  }, [item.name, sum, setValues]);

  return (
    <>
      {/* Hidden input keeps the value in the DOM if needed, while the
          visual representation is a simple label + right-aligned text. */}
      <input type="hidden" name={item.name} value={sum} />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "2rem",
        }}
      >
        {item.label && (
          <Typography
            variant="body2"
            sx={{
              fontSize: componentTokens.sumInput.label.fontSize,
              fontWeight: componentTokens.sumInput.label.fontWeight,
              mb: 0.5,
            }}
          >
            {item.label}
          </Typography>
        )}
        <Box sx={{ textAlign: "right" }}>
          <Typography
            variant="body2"
            sx={{
              fontSize: componentTokens.sumInput.value.fontSize,
              fontWeight: componentTokens.sumInput.value.fontWeight,
            }}
          >
            {getEuro(sum)}
          </Typography>
        </Box>
      </Box>
    </>
  );
}
